import React, {useEffect, useState} from "react"
import {
    Badge,
    Button,
    Col,
    Container,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalFooter,
    Row,
} from "reactstrap"
import Image from "../../components/CustomImage"
import USER from "../../graphql/queries/user";
import {useQuery} from "@apollo/react-hooks";
import withApollo from "../../lib/withApollo";
import {getDataFromTree} from "@apollo/react-ssr";
import {getSessionId} from "../../services/session";
import RemoveFromWishlistButton from "../../components/Button/RemoveFromWishlistButton";
import Link from "next/link";
import {useRouter} from "next/router";
import ModalHeader from "../../components/Modal/ModalHeader";

const Wishlist = () => {
    const router = useRouter();
    const uuid = getSessionId();
    const [user, setUser] = useState(null);
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const {loading, error, data} = useQuery(USER, {
        variables: {
            uuid: uuid
        },
    });

    useEffect(() => {
        if (data && data.user) {
            setUser(data.user);
        }
    }, [data]);

    if (loading) {
        <div>Gegevens aan het ophalen</div>
    }

    return (
        <>
            <section className="py-5">
                <Container>
                    <div className="d-flex justify-content-between align-items-end mb-3 mb-lg-4">
                        <h1 className="hero-heading mb-0">Uw verlanglijstje</h1>
                    </div>
                    <div
                        className="d-flex justify-content-between align-items-center flex-column flex-lg-row mb-3 mb-lg-5">
                        <div className="mr-3">
                            {user &&
                                <p className="mb-0 mb-lg-0">
                                    U heeft <strong>{user.wishlist.productCount} product(en)</strong> op uw
                                    verlanglijstje
                                </p>
                            }
                        </div>
                    </div>

                    {user && user.wishlist.hasUnavailableItems &&
                        <div className="alert alert-primary" role="alert">
                            Een of meerdere artikelen in uw winkelwagen zijn niet meer beschikbaar.
                            Verwijder deze artikelen om verder te kunnen gaan met uw bestelling.
                        </div>
                    }

                    {user && user.wishlist.cottageStays.length > 0 &&
                        <>
                            <h2>Cottages</h2>
                            <ListGroup className="shadow mb-5">
                                {user && user.wishlist.cottageStays.map((cottageStay) => (
                                    <ListGroupItem
                                        onClick={() => {
                                            router.push({
                                                pathname: `/vakantiehuizen/${cottageStay.cottage.slug}`,
                                            })
                                        }}
                                        action className="py-4" tag="a" key={cottageStay.id}>
                                        <Row>
                                            <Col lg="3" className="">
                                                <Image
                                                    src={cottageStay.cottage.images[0].url}
                                                    alt={cottageStay.cottage.name}
                                                    height={150}
                                                    width={225}
                                                    layout="responsive"
                                                />
                                            </Col>
                                            <Col lg="1" className="mt-4">
                                            </Col>
                                            <Col lg="4" className="">
                                                <div className="d-flex align-items-center mb-3">
                                                    <h2 className="h5 mb-0">{cottageStay.cottage.name}</h2>
                                                    {/*<div className="avatar avatar-sm avatar-border-white ml-3 overflow-hidden">*/}
                                                    {/*  <Image*/}
                                                    {/*    src={`/content/img/avatar/${booking.avatar}`}*/}
                                                    {/*    alt={booking.title}*/}
                                                    {/*    width={36}*/}
                                                    {/*    height={36}*/}
                                                    {/*    layout="fixed"*/}
                                                    {/*  />*/}
                                                    {/*</div>*/}
                                                </div>
                                                {cottageStay.cottage.tags && (
                                                    <ul className="list-inline text-sm mb-4">
                                                        {cottageStay.cottage.tags.map((tag) => (
                                                            <li key={tag.value} className="list-inline-item mr-3">
                                                                <i
                                                                    className={`fa fa-${tag.icon} mr-1 text-secondary`}
                                                                />{" "}
                                                                {tag.value}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                                {/*<p className="text-sm text-muted">{booking.type}</p>*/}
                                                <Badge
                                                    color="primary"
                                                    className="p-2"
                                                    pill
                                                >
                                                    {/*{moment(cottageStay.startDate).format('D MMM Y')} - {moment(cottageStay.endDate).format('D MMM Y')}*/}
                                                </Badge>
                                            </Col>
                                            <Col lg="1" className="mt-4">
                                            </Col>
                                            <Col lg="3" className="text-right">
                                                <Row className="mb-4">
                                                    <Col>
                                                        <RemoveFromWishlistButton
                                                            onClick={() => {
                                                                window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                                                                toggle()
                                                            }}
                                                            stayId={cottageStay.id}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Link href={`/vakantiehuizen/${cottageStay.cottage.slug}`}>
                                                            <Button color="primary">Bekijk Cottage</Button>
                                                        </Link>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </ListGroupItem>
                                ))}
                            </ListGroup>
                        </>
                    }

                    {/*{user && user.wishlist.camperTrips.length > 0 &&*/}
                    {/*<>*/}
                    {/*    <h2>Campers</h2>*/}
                    {/*    <ListGroup className="shadow mb-5">*/}
                    {/*        {user && user.wishlist.camperTrips.map((camperTrip) => (*/}
                    {/*            <ListGroupItem*/}
                    {/*                // onClick={() => (*/}
                    {/*                //     router.push({*/}
                    {/*                //       pathname: `/camper/type/${camperTrip.camper.seoId}`,*/}
                    {/*                //       query: {*/}
                    {/*                //         ophaallocatie: camperTrip.pickupLocation,*/}
                    {/*                //         afleverlocatie: camperTrip.dropOffLocation,*/}
                    {/*                //         ophaaldatum: camperTrip.pickupDate,*/}
                    {/*                //         afleverdatum: camperTrip.dropOffDate,*/}
                    {/*                //       }*/}
                    {/*                //     })*/}
                    {/*                // )}*/}
                    {/*                action className="py-4" tag="a" key={camperTrip.id}>*/}
                    {/*                <Row>*/}
                    {/*                    <Col lg="3" className="">*/}
                    {/*                        <Image*/}
                    {/*                            src={getImageUrl(camperTrip.camper.thumbnail)}*/}
                    {/*                            alt={camperTrip.camper.type}*/}
                    {/*                            height={150}*/}
                    {/*                            width={225}*/}
                    {/*                            layout="responsive"*/}
                    {/*                        />*/}
                    {/*                    </Col>*/}
                    {/*                    <Col lg="1" className="mt-4">*/}
                    {/*                    </Col>*/}
                    {/*                    <Col lg="4" className="">*/}
                    {/*                        <div className="d-flex align-items-center mb-3">*/}
                    {/*                            <h2 className="h5 mb-0">{camperTrip.camper.type}</h2>*/}
                    {/*                        </div>*/}
                    {/*                        {camperTrip.options && JSON.parse(camperTrip.options).length > 0 && (*/}
                    {/*                            <>*/}
                    {/*                                <h6>Verzekering:</h6>*/}
                    {/*                                <ul className="list-inline text-sm mb-4">*/}
                    {/*                                    <li className="list-inline-item mr-3">*/}
                    {/*                                        {JSON.parse(camperTrip.insuranceOption).name} (€{JSON.parse(camperTrip.insuranceOption).totalAmountEuro})*/}
                    {/*                                    </li>*/}
                    {/*                                </ul>*/}
                    {/*                            </>*/}
                    {/*                        )}*/}
                    {/*                        {camperTrip.options && JSON.parse(camperTrip.options).length > 0 && (*/}
                    {/*                            <>*/}
                    {/*                                <h6>Extra opties:</h6>*/}
                    {/*                                <ul className="list-inline text-sm mb-4">*/}
                    {/*                                    {JSON.parse(camperTrip.options).map((option, index) => (*/}
                    {/*                                        <li key={index} className="list-inline-item mr-3">*/}
                    {/*                                            {option.name} (€{option.totalFeeEuro})*/}
                    {/*                                        </li>*/}
                    {/*                                    ))}*/}
                    {/*                                </ul>*/}
                    {/*                            </>*/}
                    {/*                        )}*/}
                    {/*                        <Badge*/}
                    {/*                            color="primary"*/}
                    {/*                            className="p-2"*/}
                    {/*                            pill*/}
                    {/*                        >*/}
                    {/*                        </Badge>*/}
                    {/*                    </Col>*/}
                    {/*                    <Col lg="2">*/}
                    {/*                        <Row>*/}
                    {/*                            <Col className="">*/}
                    {/*                                <h6 className="label-heading">Aankomst datum</h6>*/}
                    {/*                                <p className="text-sm font-weight-bold">*/}
                    {/*                                    {moment(camperTrip.pickupDate).format('D MMM Y')}*/}
                    {/*                                </p>*/}
                    {/*                                <h6 className="label-heading">Vertrek datum</h6>*/}
                    {/*                                <p className="text-sm font-weight-bold">*/}
                    {/*                                    {moment(camperTrip.dropOffDate).format('D MMM Y')}*/}
                    {/*                                </p>*/}
                    {/*                                <h6 className="label-heading">Dagen</h6>*/}
                    {/*                                <p className="text-sm font-weight-bold mb-0">*/}
                    {/*                                    {moment(camperTrip.dropOffDate).diff(moment(camperTrip.pickupDate), 'days') + 1} dagen*/}
                    {/*                                </p>*/}
                    {/*                            </Col>*/}
                    {/*                        </Row>*/}
                    {/*                    </Col>*/}
                    {/*                    <Col lg="2" className="text-right">*/}
                    {/*                        <Row>*/}
                    {/*                            <Col>*/}
                    {/*                                <h6 className="label-heading">Prijs</h6>*/}
                    {/*                                <p className="text-sm font-weight-bold checkout-camper-price">*/}
                    {/*                                    {camperTrip.price !== undefined*/}
                    {/*                                        ? <>{!camperTrip.available ? 'Niet meer beschikbaar' : `€ ${camperTrip.price}`}</>*/}
                    {/*                                        : <span className="loader-small"></span>*/}
                    {/*                                    }*/}
                    {/*                                </p>*/}
                    {/*                            </Col>*/}
                    {/*                        </Row>*/}
                    {/*                        <Row>*/}
                    {/*                            <Col>*/}
                    {/*                                <RemoveCamperFromWishlistButton tripId={camperTrip.id}/>*/}
                    {/*                            </Col>*/}
                    {/*                        </Row>*/}
                    {/*                    </Col>*/}
                    {/*                </Row>*/}
                    {/*            </ListGroupItem>*/}
                    {/*        ))}*/}
                    {/*    </ListGroup>*/}
                    {/*</>*/}
                    {/*}*/}
                </Container>
            </section>
            <Modal isOpen={modal} toggle={toggle} centered={true} fade={false} backdropClassName="desktop-backdrop"
                   contentClassName="modal-border">
                <ModalHeader toggle={toggle}>
                    <h5>De cottage is verwijderd uit uw verlanglijstje</h5>
                </ModalHeader>
                <ModalFooter>
                    <Button color="primary" onClick={toggle}>Ok</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

Wishlist.getInitialProps = async () => {
    return {
        nav: {
            light: true,
            classes: "shadow",
            color: "white",
        },
        title: "Verlanglijstje - Cottage Centre",
    };
};

export default withApollo(Wishlist, {getDataFromTree});
